module.exports = __webpack_public_path__ + "img/active-list.82bc8fb7.svg";